import {Nullish} from './Nullish';

export type NullishBoolean = boolean | Nullish;
